<div class="me-auto text-secondary">
  Buscar:
  <div class="ms-2 d-inline-block">
    <input
      type="text"
      class="form-control form-control"
      aria-label="Search"
      (input)="onSearch($event)"
    />
  </div>
</div>
